export const calculateAge = (birthDateString, t) => {
  if (!birthDateString) return t('adoptionPage.unknown_age');

  const birthDate = new Date(birthDateString);
  const now = new Date();

  let years = now.getFullYear() - birthDate.getFullYear();
  let months = now.getMonth() - birthDate.getMonth();

  if (months < 0) {
    years--;
    months += 12;
  }

  const totalMonths = years * 12 + months;

  if (totalMonths < 12) {
    if (totalMonths === 1) return t('common.age.month_one');
    if (totalMonths >= 2 && totalMonths <= 4) return t('common.age.month_few', { count: totalMonths });
    return t('common.age.month_many', { count: totalMonths });
  } else {
    if (years === 1) return t('common.age.year_one');
    if (years >= 2 && years <= 4) return t('common.age.year_few', { count: years });
    return t('common.age.year_many', { count: years });
  }
};
